"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cookies = require("browser-cookies");
var en_1 = require("./messages/en");
var no_1 = require("./messages/no");
var sv_1 = require("./messages/sv");
var da_1 = require("./messages/da");
var fi_1 = require("./messages/fi");
var lv_1 = require("./messages/lv");
var pl_1 = require("./messages/pl");
var de_1 = require("./messages/de");
var is_1 = require("./messages/is");
var tokenizer_1 = require("./tokenizer");
var messageProxy_1 = require("./messageProxy");
var languageChangeListeners = [];
var COOKIE_NAME = 'selected_lang';
var messagesPerCode = {
    en: en_1.Messages,
    no: no_1.Messages,
    sv: sv_1.Messages,
    da: da_1.Messages,
    fi: fi_1.Messages,
    lv: lv_1.Messages,
    pl: pl_1.Messages,
    de: de_1.Messages,
    is: is_1.Messages,
};
var selectedLanguage;
var Translation;
(function (Translation) {
    Translation.tokenize = tokenizer_1.tokenize;
    Translation.MessagesType = en_1.Messages;
    // !!! The languages listed here should have an appropriate {languageCode}.ts file under messages folder !!!
    Translation.supportedLanguages = [
        { languageCode: 'en', name: 'English' },
        { languageCode: 'no', name: 'Norsk' },
        { languageCode: 'sv', name: 'Svenska' },
        { languageCode: 'da', name: 'Dansk' },
        { languageCode: 'fi', name: 'Suomi' },
        { languageCode: 'lv', name: 'Latviešu' },
        { languageCode: 'pl', name: 'Polski' },
        { languageCode: 'de', name: 'Deutsch' },
        { languageCode: 'is', name: 'Íslenska' },
    ];
    // All languages that are allowed, but not necessarily in use
    var allowedLanguages = Translation.supportedLanguages.slice();
    // Supported languages the user can choose from
    function isSupportedLanguage(languageCode) {
        return Translation.supportedLanguages.some(function (language) { return language.languageCode === languageCode; });
    }
    Translation.isSupportedLanguage = isSupportedLanguage;
    // Includes languages the user can't choose (languages that are being tested)
    function isAllowedLanguage(languageCode) {
        return allowedLanguages.some(function (language) { return language.languageCode === languageCode; });
    }
    Translation.isAllowedLanguage = isAllowedLanguage;
    function getEffectiveLanguage(languageCode) {
        if (isAllowedLanguage(languageCode)) {
            return languageCode;
        }
        return 'en';
    }
    Translation.getEffectiveLanguage = getEffectiveLanguage;
    function messagesOf(languageCode) {
        var shouldShowTranslationKeys = cookies.get("addTranslationKeys");
        // Prefix all messages if cookie is set
        if (!(shouldShowTranslationKeys === "" || shouldShowTranslationKeys === null || shouldShowTranslationKeys === undefined)) {
            return messageProxy_1.proxyMessagesObject(messagesPerCode[languageCode]);
        }
        if (isAllowedLanguage(languageCode)) {
            return messagesPerCode[languageCode];
        }
        return en_1.Messages;
    }
    Translation.messagesOf = messagesOf;
    function messages() {
        return messagesOf(getSelectedLanguage());
    }
    Translation.messages = messages;
    function country(countryCode) {
        return messagesOf(getSelectedLanguage()).countries[countryCode];
    }
    Translation.country = country;
    function getSelectedLanguage() {
        return selectedLanguage;
    }
    Translation.getSelectedLanguage = getSelectedLanguage;
    /**
     * Returns language code compatible with the browser
     *
     * Most notably it will return nb for Norwegian
     */
    function getSelectedBrowserLanguage() {
        switch (selectedLanguage) {
            case 'no':
                return 'nb';
            default:
                return selectedLanguage;
        }
    }
    Translation.getSelectedBrowserLanguage = getSelectedBrowserLanguage;
    /**
     * Returns language code compatible with the browser
     *
     * Most notably it will return nb for Norwegian and en-GB for English
     */
    function getSelectedBrowserLocale() {
        switch (selectedLanguage) {
            case 'no':
                return 'nb';
            case 'en':
                return 'en-GB';
            default:
                return selectedLanguage;
        }
    }
    Translation.getSelectedBrowserLocale = getSelectedBrowserLocale;
    function getSelectedLanguageName() {
        if (!isAllowedLanguage(getSelectedLanguage())) {
            return 'N/A';
        }
        return allowedLanguages.find(function (language) { return language.languageCode === selectedLanguage; }).name;
    }
    Translation.getSelectedLanguageName = getSelectedLanguageName;
    function setSelectedLanguage(languageCode, overrideToEnglish) {
        var effectiveLangCode = Translation.getEffectiveLanguage(languageCode);
        var oldCode = selectedLanguage;
        cookies.set(COOKIE_NAME, effectiveLangCode, { expires: 730 });
        if (overrideToEnglish) {
            selectedLanguage = 'en';
        }
        else {
            selectedLanguage = effectiveLangCode;
        }
        languageChangeListeners.forEach(function (listener) { return listener(oldCode, selectedLanguage); });
    }
    Translation.setSelectedLanguage = setSelectedLanguage;
    function addLanguageChangeListener(listener) {
        languageChangeListeners.push(listener);
    }
    Translation.addLanguageChangeListener = addLanguageChangeListener;
    /**
     * Makes it possible to locally in a project override the selected language to English.
     * This does not change the saved cookie value of selected_lang so other projects that do
     * support the selected language can still be view in that language.
     * For example only enduser should be in Icelandic, but not tenant and landlord.
     */
    function overrideToEnglish(languagesToOverride) {
        if (languagesToOverride.indexOf(selectedLanguage) !== -1) {
            setSelectedLanguage(selectedLanguage, true);
        }
    }
    Translation.overrideToEnglish = overrideToEnglish;
    // Our scopes take the form [object].[resource]:[operation]
    // e.g. users.profile:read
    function translateAuthServerScope(scopeId) {
        // We dont care about the [object], find it so we can ignore it.
        var split = scopeId.split('.');
        if (!split[1]) {
            return undefined;
        }
        split = split[1].split(':');
        if (!split[0] || !split[1]) {
            return undefined;
        }
        // Get the resource and operation
        var _a = [split[0], split[1]], resource = _a[0], operation = _a[1];
        // Create a string that will match our translation key. 
        // In the users.profile:read example, this would be read_profile 
        var propertyValue = operation + "_" + resource;
        return messages().enduser.oauth.scopes[propertyValue];
    }
    Translation.translateAuthServerScope = translateAuthServerScope;
    function getCookieLanguageOrNull() {
        var cookieLanguage = cookies.get(COOKIE_NAME);
        return isAllowedLanguage(cookieLanguage) ? cookieLanguage : null;
    }
    // Use list of supported languages for browser language, so users dont't accidentally
    // get an unsupported allowed language (typically an unreleased language that is being tested)
    function getSupportedBrowserLanguageOrNull() {
        if (!navigator.languages) {
            return extractSupportedLanguageOrNull(navigator.language);
        }
        for (var _i = 0, _a = navigator.languages; _i < _a.length; _i++) {
            var browserLanguage = _a[_i];
            var supportedLanguage = extractSupportedLanguageOrNull(browserLanguage);
            if (supportedLanguage) {
                return supportedLanguage;
            }
        }
        return extractSupportedLanguageOrNull(navigator.language);
    }
    function extractSupportedLanguageOrNull(language) {
        if (!language) {
            return null;
        }
        var twoLetterLanguageCode = language.substring(0, 2);
        if (twoLetterLanguageCode === 'nb' || twoLetterLanguageCode === 'nn') {
            twoLetterLanguageCode = 'no';
        }
        return isSupportedLanguage(twoLetterLanguageCode) ? twoLetterLanguageCode : null;
    }
    selectedLanguage = getCookieLanguageOrNull() || getSupportedBrowserLanguageOrNull() || 'en';
})(Translation = exports.Translation || (exports.Translation = {}));
